import React, { useEffect, useMemo, useState } from "react";
import Stack from "./ui/Stack";
import Card from "./ui/card/Card";
import Button from "./common/button/Button";
import { RoleSign } from "../enums/enums";
import { logout } from "../store/auth-slice";
import { useDispatch } from "react-redux";

const SelectRole = ({ user, onSelectRole }) => {
    const [selectedScopeId, setSelectedScopeId] = useState("");
    const userRole = useMemo(() => user?.userRole || [], [user?.userRole]);
    const dispatch = useDispatch();

    const formatRole = (role) => ({
        role: role.role,
        roleSign: RoleSign[role.role],
        scope: role.scope,
        scopeId: role.scopeId._id,
        scopeName: role.scopeId.name,
        branchType: role.scopeId?.branchType,
        user: role.user,
        address: role.scopeId.address,
        restaurantName: role.scopeId.restaurantName
    });

    useEffect(() => {
        if (userRole.length === 1) {
            const role = userRole[0];
            onSelectRole(formatRole(role));
        }
    }, [userRole, onSelectRole]);

    useEffect(() => {
        if (!userRole || userRole.length === 0) {
            if (user.role === "SuperAdmin") {
                onSelectRole({
                    role: "Admin",
                    scope: "Super",
                    roleSign: RoleSign.SuperAdmin,
                });
            }
        }
    }, [userRole, onSelectRole, user.role]);

    const logoutHandler = () => {
        dispatch(logout());
    };

    if (!userRole || userRole.length === 0) {
        if (user.role === "Customer") {
            return (
                <div className="container-fluid p-0 vh-100">
                    <div className="row h-100 g-0">
                        <div className="col">
                            <Stack className="align-items-center justify-content-center h-100">
                                <div className="w-100 px-4 text-center" style={{ maxWidth: "400px" }}>
                                    <h6 className="fw-semibold mb-3">User does not have any assigned roles.</h6>
                                    <Button
                                        className="bg-primary bg-opacity-75 bg-opacity-100-hover"
                                        type="button"
                                        onClick={logoutHandler}
                                    >
                                        Logout
                                    </Button>
                                </div>
                            </Stack>
                        </div>
                    </div>
                </div>
            );
        }
    }

    return (
        <div className="container vh-100 py-8">
            <div className="row h-100 align-content-center justify-content-center g-4">
                    {userRole.map((role) => (
                        <div className="col-md-6">
                            <Card key={role.scopeId._id} className="card-hover border-0" style={{ "--bs-card-spacer-y": '0', "--bs-card-spacer-x": '0'}}> {/*bg-primary bg-opacity-25 bg-opacity-50-hover*/}
                                <div className="form-check d-flex p-0">
                                    <input
                                        style={{ transform: "scale(1.1)" }}
                                        className="form-check-input border-secondary my-2 me-3 d-none"
                                        type="radio"
                                        id={role.scopeId._id}
                                        value={role.scopeId._id}
                                        checked={selectedScopeId === role.scopeId._id}
                                        onChange={() => {
                                            setSelectedScopeId(role.scopeId._id);
                                            onSelectRole(formatRole(role));
                                        }}
                                    />
                                    <label
                                        className="form-check-label user-select-none flex-grow-1 p-8 mb-0"
                                        htmlFor={role.scopeId._id}
                                        role="button"
                                    >
                                        <h3 className="d-block fs-2 fw-bold mb-n1">{role.scopeId.name}</h3>
                                        <span className="fw-medium text-secondary fs-4 fs-sm">{role.scope}</span>
                                    </label>
                                </div>
                            </Card>
                        </div>
                    ))}
            </div>
        </div>
    );
};

export default SelectRole;
